import type { Identity } from "../../types/auth";
import { getEventTeamPerms } from "../../utils/eventTeamPermissions";
export function formPermissions(identity: Identity | null, isDev = false) {
  const event = getEventTeamPerms(identity, isDev),
    p = identity?.raw?.custom?.permissions || [],
    g = identity?.raw?.custom?.groups || [];
  const admin =
    isDev || g.includes("SPY_Super_admin") || p.includes("argus.forms.admin");
  const write = admin || p.includes("argus.forms.write") || event.canCreate;
  return {
    read: write || p.includes("argus.forms.read") || event.canView,
    write,
    events: event.canCreate,
    rewards: admin || p.includes("argus.forms.rewards") || event.canPoints,
  };
}
